export default __webpack_public_path__ + "static/media/logo.0ff2b4a5.svg";